import { KYBER_CRYSTAL_OF, RARITY_LABEL, isMascotRarity } from './kyberCrystal.js';
const COLLECTION_ID = /^[a-z0-9][a-z0-9-]{0,31}$/;
const SERIAL_MAX = 100_000;
/**
 * An outfit's economy fields in a LooksView (gyro-svc economyTileFields), folded into one object, or undefined when they
 * are absent (an older gyro-svc, or the economy off) or malformed: that outfit then shows no crystal, and the rest of it
 * stays. The crystal always follows the rarity, whatever the answer says.
 */
export function parseMascotEconomy(fields) {
    const { rarity, serial, copies, supply, soldOut, collectionId, tradeable, retired } = fields;
    if (!isMascotRarity(rarity) || typeof soldOut !== 'boolean' || typeof tradeable !== 'boolean')
        return undefined;
    if (typeof copies !== 'number' || !Number.isSafeInteger(copies) || copies < 0)
        return undefined;
    let bounded;
    if (supply === 'unlimited')
        bounded = 'unlimited';
    else if (supply && typeof supply === 'object' && !Array.isArray(supply)) {
        const { cap, minted } = supply;
        if (typeof cap !== 'number' || !Number.isSafeInteger(cap) || cap < 1 || typeof minted !== 'number' || !Number.isSafeInteger(minted) || minted < 0 || minted > cap)
            return undefined;
        bounded = { cap, minted };
    }
    else
        return undefined;
    if (serial !== undefined && (typeof serial !== 'number' || !Number.isSafeInteger(serial) || serial < 1 || serial > SERIAL_MAX))
        return undefined;
    if (collectionId !== undefined && (typeof collectionId !== 'string' || !COLLECTION_ID.test(collectionId)))
        return undefined;
    return {
        rarity,
        crystal: KYBER_CRYSTAL_OF[rarity],
        ...(serial !== undefined ? { serial } : {}),
        copies,
        supply: bounded,
        soldOut,
        ...(collectionId !== undefined ? { collectionId } : {}),
        tradeable,
        ...(retired === true ? { retired: true } : {}),
    };
}
/** The lines a card shows for an outfit's economy fields. */
export function outfitCardLines(economy) {
    const rarityText = RARITY_LABEL[economy.rarity];
    const owned = economy.copies > 0;
    let copiesText;
    if (economy.supply === 'unlimited')
        copiesText = owned ? 'Yours · unlimited' : 'Unlimited copies';
    else if (owned && economy.serial !== undefined)
        copiesText = `#${economy.serial} of ${economy.supply.cap}${economy.copies > 1 ? ` · ${economy.copies} copies` : ''}`;
    else if (owned)
        copiesText = `Yours · ${economy.supply.cap} copies`;
    else
        copiesText = `${economy.supply.minted} of ${economy.supply.cap} copies given out`;
    const badges = [];
    if (economy.soldOut)
        badges.push('Sold out');
    if (economy.retired)
        badges.push('Retired');
    return { rarity: economy.rarity, crystal: economy.crystal, rarityText, copiesText, badges, summary: [rarityText, ...(owned && economy.serial !== undefined && economy.supply !== 'unlimited' ? [`#${economy.serial} of ${economy.supply.cap}`] : []), ...badges].join(' · ') };
}
//# sourceMappingURL=outfitCardWords.js.map